module.exports = __webpack_public_path__ + "img/john-legend.e7c9e4be.jpg";